// extracted by mini-css-extract-plugin
export default {"grid-ctr":"AddProcess_grid-ctr__cZWkR","left-color":"AddProcess_left-color__L2PaS","hovered-process":"AddProcess_hovered-process__vCV8Y"};